import { render, staticRenderFns } from "./AwayCard.vue?vue&type=template&id=3b19bcd8&scoped=true&"
import script from "./AwayCard.vue?vue&type=script&lang=js&"
export * from "./AwayCard.vue?vue&type=script&lang=js&"
import style0 from "./AwayCard.vue?vue&type=style&index=0&id=3b19bcd8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b19bcd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCol,VContainer,VHover,VIcon,VRow,VSkeletonLoader})
